import React from 'react';
// import './styles.css';
import Lottie from 'lottie-react';
import animationData from './animation.json';

const Writer = () => <Lottie animationData={animationData} loop={true} style={{height:"300px"}}/>;
  export default Writer;